import * as React from 'react';

import './TermsOfServiceAcceptanceDialog.scss';

import Button from 'common/components/core/Button/Button';
import Icons from 'common/icons';

import type { TermsOfServiceVersionResponse } from '../fragments';

export const EMPTY_TERMS: TermsOfServiceVersionResponse = {
  id: '',
  tosLink: '',
  tosVersion: '',
};

export interface TermsOfServiceAcceptanceProps {
  currentTos: TermsOfServiceVersionResponse;
  acceptTerms: (version: string) => void;
}

export default function TermsOfServiceAcceptanceDialog(props: TermsOfServiceAcceptanceProps) {
  const acceptTerms = () => props.acceptTerms(props.currentTos.tosVersion);

  return (
    <div className="onboarding">
      <div className="onboarding-box">
        <div className="onboarding-title mb-l">
          NUTANIX CLOUD SERVICES <br />
          TERMS OF SERVICE
        </div>
        <div className="mb-l text-justify">
          By clicking the ‘I Accept’ button below you are accepting the
          <a href="/tos" target="_blank">
            {' '}
            Nutanix Cloud Terms of Services
          </a>
          .
        </div>
        <Button className="accept-button" onClick={acceptTerms}>
          I Accept
        </Button>
        <img className="onboarding-box__logo" src={Icons.NUTANIX_TYPE_LIGHT} alt="Nutanix" />
      </div>
    </div>
  );
}
